export default __webpack_public_path__ + "static/wellness-buddy-pocket-7bb881d6.jpg";